import { unities } from "@/common/constants/unities.constants";
import { formatCurrency, formatDecimal, formatUnit } from "@/common/utils/formatters";
import { BranchesEquipmentsConsumptionsTotalizerProductData } from "../types/branchesEquipmentsConsumptionsTotalizer.type";

export class BranchesEquipmentsConsumptionsTotalizerTransformer {

  static productsTableTransformer() {
    return (products: BranchesEquipmentsConsumptionsTotalizerProductData[]) => {
      return products.map((product) => {
        return {
          displayName: product.display_name,
          totalQuantity: product.total_quantity
            ? formatUnit(formatDecimal(product.total_quantity, 4, 2), product.unit)
            : '--',
          accumulatedUsage: product.accumulated_usage
            ? formatUnit(formatDecimal(product.accumulated_usage, 0), 'kilometers')
            : '--',
          averageUsagePerQuantity: product.average_usage_per_quantity
            ? formatUnit(
              formatDecimal(product.average_usage_per_quantity, 4, 2),
              `${unities['kilometers']}/${product.unit}`
            )
            : '--',
          totalValue: product.total_value
            ? formatCurrency(Number(product.total_value))
            : '--',
        };
      });
    }
  }

}
